export enum CorporatePages {
    PrivacyPolicy = '/content/pp.txt',
    TermsAndConditions = '/content/tou.txt',
}
